import { createPlugin } from '@backstage/core-plugin-api';
import { readmeApiFactory } from './api';

export const readmePlugin = createPlugin({
  id: 'readme',
  apis: [readmeApiFactory],
});

export default readmePlugin;
